module.exports = __webpack_public_path__ + "media/images/logos/linkedIn-09c0111b09e0915bc21cafb81d802eca.svg";